import { TOGGLE_MENU } from './menu.actions'

const INITIAL_STATE = {
  isOpen: false,
}

export function menuReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TOGGLE_MENU:
      return { isOpen: !state.isOpen }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/menu/menu.reducers.js